import policiesActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';

export const reducers = {
  query: createAsyncRequestReducer(policiesActionTypes.FETCH_POLICIES),
  create: createAsyncRequestReducer(policiesActionTypes.CREATE_POLICY),
  delete: createAsyncRequestReducer(policiesActionTypes.DELETE_POLICY),
  update: createAsyncRequestReducer(policiesActionTypes.UPDATE_POLICY),
};

export default combineReducers(reducers);
